const browsers = [
  ['aol', /AOLShield\/([0-9._]+)/],
  ['firefox', /Firefox\/([0-9.]+)(?:\s|$)/],
  ['opera', /Opera\/([0-9.]+)(?:\s|$)/],
  ['opera', /OPR\/([0-9.]+)(:?\s|$)/],
  ['edge', /Edge\/([0-9._]+)/],
  ['edge-ios', /EdgiOS\/([0-9._]+)/],
  ['edge-chromium', /Edg\/([0-9.]+)/],
  ['chromium-webview', /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9.]+)(:?\s|$)/],
  ['ie', /Trident\/7\.0.*rv:([0-9.]+).*\).*Gecko$/],
  ['ie', /MSIE\s([0-9.]+);.*Trident\/[4-7].0/],
  ['ie', /MSIE\s(7\.0)/],
  ['safari', /Version\/([0-9._]+).*Safari/],
  ['chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9.]+)(:?\s|$)/],
  ['bb10', /BB10;\sTouch.*Version\/([0-9.]+)/],
  ['android', /Android\s([0-9.]+)/],
  ['ios', /Version\/([0-9._]+).*Mobile.*Safari.*/],
  ['yandexbrowser', /YaBrowser\/([0-9._]+)/],
  ['crios', /CriOS\/([0-9.]+)(:?\s|$)/],
  ['vivaldi', /Vivaldi\/([0-9.]+)/],
  ['kakaotalk', /KAKAOTALK\s([0-9.]+)/],
  ['samsung', /SamsungBrowser\/([0-9.]+)/],
  ['silk', /\bSilk\/([0-9._-]+)\b/],
  ['miui', /MiuiBrowser\/([0-9.]+)$/],
  ['beaker', /BeakerBrowser\/([0-9.]+)/],
  ['phantomjs', /PhantomJS\/([0-9.]+)(:?\s|$)/],
  ['fxios', /FxiOS\/([0-9.]+)/],
  ['opera-mini', /Opera Mini.*Version\/([0-9.]+)/],
  ['facebook', /FBAV\/([0-9.]+)/],
  ['instagram', /Instagram\s([0-9.]+)/],
  ['ios-webview', /AppleWebKit\/([0-9.]+).*Mobile/],
  ['ios-webview', /AppleWebKit\/([0-9.]+).*Gecko\)$/],
];

export default browsers;
